import { getCore as get, postCore as post } from "../../utils/httpInterceptor";

class MfaService {
  static status() {
    return get("/api/me/mfa/status");
  }

  static setup() {
    return post("/api/me/mfa/setup", {});
  }

  static activate(code) {
    return post("/api/me/mfa/activate", { code });
  }

  static disable(currentPassword, code) {
    return post("/api/me/mfa/disable", { currentPassword, code });
  }

  static regenerateRecoveryCodes(currentPassword, code) {
    return post("/api/me/mfa/recovery-codes/regenerate", { currentPassword, code });
  }
}

export default MfaService;
